class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items') || this.closest('cart-drawer-items');
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {    
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status') || document.getElementById('CartDrawer-LineItemStatus');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));

console.log('changed');
    
    // Check for specific products in cart
    function checkForSpecificItems() {
      // Select all elements with class .cart-item__name
      const cartItems = document.querySelectorAll('.cart-item__name');
    
      // Loop through each cart item
      for (let item of cartItems) {
        // Normalize the item text: convert to lowercase and remove special characters
        const itemName = item.textContent.toLowerCase().replace(/[^a-z0-9\s]/gi, '');
    
        // Check if the normalized item name contains "maxine one" or "brodie"
        if (itemName.includes("maxine one") || itemName.includes("brodie one")) {
          // If a match is found, add class 'checkout-step' to the element with id #CartDrawer-Checkout
          //document.getElementById('CartDrawer-Checkout').classList.add('checkout-step');
          return true; // Return true to indicate a match was found
        }
      }
    
      return false; // Return false if no match is found
    }
    
    // Usage example
    if (checkForSpecificItems()) {
      console.log("1Found an item and added the 'checkout-step' class to #CartDrawer-Checkout.");
      document.querySelector('.drawer__footer #CartDrawer-Checkout').classList.add('disabled');
      document.querySelector('.drawer__footer .checkout-step').classList.add('active');
      console.log('added to cart1');

      // Calculate Free Shipping excluding specific products
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const freeShippingThreshold = 150.00;
      
          // 🛑 Define products to exclude by name (case-insensitive)
          const excludedProducts = [
            'The Chonk Crew',
            'Custom Backpack Patch'
          ];
      
          // 🧮 Calculate subtotal excluding excluded products
          const includedSubtotalCents = cart.items.reduce((total, item) => {
            const isExcluded = excludedProducts.some(exName =>
              item.title.trim().toLowerCase().includes(exName.toLowerCase())
            );
            return isExcluded ? total : total + item.final_line_price;
          }, 0);
      
          const includedSubtotalDollars = (includedSubtotalCents / 100).toFixed(2);
      
          // 🎯 Free shipping messages
          const fsb1 = "Free shipping for orders over $150.00!";
          const fsb3 = "Congratulations! You’ve got free shipping!";
          let fsb2 = "";
      
          if (includedSubtotalCents >= freeShippingThreshold * 100) {
            fsb2 = fsb3;
          } else {
            const remainingAmount = (freeShippingThreshold - includedSubtotalDollars).toFixed(2);
            fsb2 = `You’re only $${remainingAmount} away from free shipping!`;
          }
      
          // 📈 Calculate progress percentage
          const progressPercent = Math.min(
            Math.round((includedSubtotalDollars / freeShippingThreshold) * 100),
            100
          );
          console.log(`${progressPercent}%`);
          console.log(fsb2);
      
          // 🖋️ Update text
          const fsbTitleElement = document.querySelector('.fsb-title');
          if (fsbTitleElement) {
            fsbTitleElement.textContent = fsb2;
          }
      
          // 📊 Update progress bar width
          const progressBar = document.querySelector('.fsb-progress-bar');
          if (progressBar) {
            progressBar.style.width = `${progressPercent}%`;
          }
      
          // 📤 Dispatch event
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              total_price: cart.total_price,
              cart: cart
            }
          });
          document.dispatchEvent(cartUpdatedEvent);
        });
        // Calculate Free Shipping excluding specific products - ends

    } else {
      console.log("1No matching items found.");
      document.querySelector('.drawer__footer #CartDrawer-Checkout').classList.remove('disabled');
      document.querySelector('.drawer__footer .checkout-step').classList.remove('active');
      console.log('added to cart2');

      // Calculate Free Shipping excluding specific products
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const freeShippingThreshold = 150.00;
      
          // 🛑 Define products to exclude by name (case-insensitive)
          const excludedProducts = [
            'Little Chonk Mascot Pennant',
            'Custom Backpack Patch'
          ];
      
          // 🧮 Calculate subtotal excluding excluded products
          const includedSubtotalCents = cart.items.reduce((total, item) => {
            const isExcluded = excludedProducts.some(exName =>
              item.title.trim().toLowerCase().includes(exName.toLowerCase())
            );
            return isExcluded ? total : total + item.final_line_price;
          }, 0);
      
          const includedSubtotalDollars = (includedSubtotalCents / 100).toFixed(2);
      
          // 🎯 Free shipping messages
          const fsb1 = "Free shipping for orders over $150.00!";
          const fsb3 = "Congratulations! You’ve got free shipping!";
          let fsb2 = "";
      
          if (includedSubtotalCents >= freeShippingThreshold * 100) {
            fsb2 = fsb3;
          } else {
            const remainingAmount = (freeShippingThreshold - includedSubtotalDollars).toFixed(2);
            fsb2 = `You’re only $${remainingAmount} away from free shipping!`;
          }
      
          // 📈 Calculate progress percentage
          const progressPercent = Math.min(
            Math.round((includedSubtotalDollars / freeShippingThreshold) * 100),
            100
          );
          console.log(`${progressPercent}%`);
          console.log(fsb2);
      
          // 🖋️ Update text
          const fsbTitleElement = document.querySelector('.fsb-title');
          if (fsbTitleElement) {
            fsbTitleElement.textContent = fsb2;
          }
      
          // 📊 Update progress bar width
          const progressBar = document.querySelector('.fsb-progress-bar');
          if (progressBar) {
            progressBar.style.width = `${progressPercent}%`;
          }
      
          // 📤 Dispatch event
          const cartUpdatedEvent = new CustomEvent('cart:updated', {
            detail: {
              total_price: cart.total_price,
              cart: cart
            }
          });
          document.dispatchEvent(cartUpdatedEvent);
        });
        // Calculate Free Shipping excluding specific products - ends    
      
    }



  //console.log('start');
  // Function to handle the click event
function handleClick() {
    document.querySelector('#CartDrawer-Overlay').click();
    openModal();    
}

// Add event listener to all elements with the class 'checkout-step'
document.querySelectorAll('.checkout-step').forEach(function(element) {
    element.addEventListener('click', handleClick);
});
  }

  onChange(event) {
    this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'));
    //console.log('cart changed');
  }


  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents',
      }
    ];
  }
/*
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, parsedState.item_count);
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`)) : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'))
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'))
        }
        this.disableLoading();
      }).catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }*/
  updateQuantity(line, quantity, name) {
    this.enableLoading(line);
  
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
  
    return fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } }) // ← return here
      .then((response) => response.text())
      .then((state) => {
        const parsedState = JSON.parse(state);
        this.classList.toggle('is-empty', parsedState.item_count === 0);
  
        const cartDrawerWrapper = document.querySelector('cart-drawer');
        const cartFooter = document.getElementById('main-cart-footer');
  
        if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
        if (cartDrawerWrapper) cartDrawerWrapper.classList.toggle('is-empty', parsedState.item_count === 0);
  
        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
          elementToReplace.innerHTML =
            this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        }));
  
        this.updateLiveRegions(line, parsedState.item_count);
  
        const lineItem = document.getElementById(`CartItem-${line}`) || document.getElementById(`CartDrawer-Item-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) {
          cartDrawerWrapper
            ? trapFocus(cartDrawerWrapper, lineItem.querySelector(`[name="${name}"]`))
            : lineItem.querySelector(`[name="${name}"]`).focus();
        } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper.querySelector('.drawer__inner-empty'), cartDrawerWrapper.querySelector('a'));
        } else if (document.querySelector('.cart-item') && cartDrawerWrapper) {
          trapFocus(cartDrawerWrapper, document.querySelector('.cart-item__name'));
        }
  
        this.disableLoading();
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        const errors = document.getElementById('cart-errors') || document.getElementById('CartDrawer-CartErrors');
        errors.textContent = window.cartStrings.error;
        this.disableLoading();
      });
  }
  

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError = document.getElementById(`Line-item-error-${line}`) || document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement = document.getElementById(`Quantity-${line}`) || document.getElementById(`Drawer-quantity-${line}`);
      lineItemError
        .querySelector('.cart-item__error-text')
        .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          quantityElement.value
        );
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text') || document.getElementById('CartDrawer-LiveRegionText');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.add('cart__items--disabled');

    const cartItemElements = this.querySelectorAll(`#CartItem-${line} .loading-overlay`);
    const cartDrawerItemElements = this.querySelectorAll(`#CartDrawer-Item-${line} .loading-overlay`);

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) => overlay.classList.remove('hidden'));

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    const mainCartItems = document.getElementById('main-cart-items') || document.getElementById('CartDrawer-CartItems');
    mainCartItems.classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);

if (!customElements.get('cart-note')) {
  customElements.define('cart-note', class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      }, 300))
    }
  });
};
